import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import SectionHeading from "@/components/SectionHeading";
import { Stagger, StaggerItem, FadeUp } from "@/components/Reveal";
import { ARTICLES } from "@/data/articles";

const BlogTeaser = () => (
  <section data-testid="blog-teaser-section" className="border-t border-raiz-900/10 bg-cream py-20 lg:py-28">
    <div className="container-x">
      <div className="flex flex-wrap items-end justify-between gap-6">
        <SectionHeading eyebrow="Conteúdos" title="Para compreender melhor" testId="blog-teaser" />
        <FadeUp delay={0.2}>
          <Link
            to="/conteudos"
            data-testid="blog-teaser-all-link"
            className="group inline-flex items-center gap-2 text-sm font-medium text-raiz-800"
          >
            Ver todos os conteúdos
            <ArrowRight aria-hidden="true" className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1.5" />
          </Link>
        </FadeUp>
      </div>
      <Stagger className="mt-14 grid gap-6 md:grid-cols-3" gap={0.12}>
        {ARTICLES.slice(0, 3).map((a) => (
          <StaggerItem key={a.slug} className="h-full">
            <Link
              to={`/conteudos/${a.slug}`}
              data-testid={`blog-teaser-${a.slug}`}
              className="group flex h-full flex-col rounded-3xl border border-raiz-900/10 bg-paper p-8 transition-all duration-500 hover:-translate-y-1.5 hover:border-raiz-600/50"
            >
              <p className="text-[11px] uppercase tracking-[0.28em] text-raiz-600">{a.category}</p>
              <h3 className="mt-4 font-serif text-xl font-normal leading-snug text-ink lg:text-2xl">{a.title}</h3>
              <p className="mt-4 flex-1 text-sm leading-relaxed text-ink/60">{a.excerpt}</p>
              <span className="mt-8 inline-flex items-center gap-2 text-sm text-raiz-700">
                Ler conteúdo
                <ArrowRight aria-hidden="true" className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1.5" />
              </span>
            </Link>
          </StaggerItem>
        ))}
      </Stagger>
    </div>
  </section>
);

export default BlogTeaser;
